// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__6HZof","content":"RecentSearches_content__1Onx5"};